import { render, staticRenderFns } from "./info-header.vue?vue&type=template&id=0bb5c9a4&scoped=true&"
import script from "./info-header.vue?vue&type=script&lang=js&"
export * from "./info-header.vue?vue&type=script&lang=js&"
import style0 from "./info-header.vue?vue&type=style&index=0&id=0bb5c9a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5c9a4",
  null
  
)

export default component.exports